import type { CommentShapeLocation } from '../domains/comments/models/Comment';

export type CommentPlacementBounds = { x: number; y: number; width: number; height: number };

export type CommentPlacementShapeStub = { getBounds: () => CommentPlacementBounds };

export function computeCommentRelativeLocOnShape(
  shapeId: string,
  diagramPoint: { x: number; y: number },
  shapes: Map<string, CommentPlacementShapeStub>,
): CommentShapeLocation | null {
  const shape = shapes.get(shapeId);
  if (!shape || typeof shape.getBounds !== 'function') {
    return null;
  }

  const bounds = shape.getBounds();
  const width = typeof bounds.width === 'number' ? bounds.width : 0;
  const height = typeof bounds.height === 'number' ? bounds.height : 0;
  const baseX = typeof bounds.x === 'number' ? bounds.x : 0;
  const baseY = typeof bounds.y === 'number' ? bounds.y : 0;

  if (width <= 0 || height <= 0) {
    return null;
  }

  const clamp = (value: number) => {
    if (Number.isNaN(value) || !Number.isFinite(value)) {
      return 0;
    }
    return Math.max(0, Math.min(1, value));
  };

  const relativeX = clamp((diagramPoint.x - baseX) / width);
  const relativeY = clamp((diagramPoint.y - baseY) / height);

  return {
    x: { type: 'relative', value: relativeX },
    y: { type: 'relative', value: relativeY },
  };
}
